<template>
  <div class="ai-content">
  <!-- <img src="@/assets/ai/background@3x.png" width="100%"/> -->
    <ul ref="box" class="ai-content-list"  v-infinite-scroll="loadMore"
  infinite-scroll-disabled="loading"
  infinite-scroll-distance="10">
        <li class="ai-content-list-tips">
          <div class="ai-content-list-tips-temp">
            <div class="flex-row-center flex-align-center temp-header">
              <img src="@/assets/ai/wxts@3x.png" width="30" height="29" />
              <span>温馨提示</span>
            </div>
            <div class="temp-section">
              <div class="title">重急症不适合在线预约，建议及时去医院就诊</div>
              <div class="flex-row flex-align-center tips">
                <img src="@/assets/ai/ysbh@3x.png" width="34" height="36" />
                <span>隐私保护·合理建议·优质医生</span>
              </div>
            </div>
          </div>
          <img class="img-right" src="@/assets/ai/l_image@3x.png" width="102" height="8" />
        </li>
        <li class="flex-row-center  flex-align-center fengexian">
          <img src="@/assets/ai/fengexian@3x.png" width="181" height="210" />
        </li>
        <li class="ai-content-list-item" :class="{'out-item':item.msgType=='out','in-item':item.msgType=='in'}" v-for="(item,index) in listData" :key="index">
            <div class="item-context" v-if="item.type=='answer'" :class="{'out':item.msgType=='out','in':item.msgType=='in'}"><span v-html="item.content"></span></div>
            <div class="doctor-list in-list" v-if="item.type=='doctorList'">
              <div class="flex-row doctor-list-item" v-for="(eItem,eIndex) in item.list" :key="eIndex" @click="handleItem(eItem)">
                <div class="doctor-avatar">
                    <img class="doctor-avatar" :src="eItem.thumb" />
                    <div class="doctor-duodian" v-if="eItem.is_duodian==1">多点执业</div>
                </div>
                <div class="item-temp">
                  <div class="flex-row flex-align-center doctor-details">
                    <div class="doctor-title">{{ eItem.name }}</div>
                    <div class="doctor-level">{{ eItem.title }}</div>
                  </div>
                  <div class="flex-row flex-align-center hospital-details">
                     {{ eItem.job_description }}
                  </div>
                  <div class="goodat">{{ eItem.goodat }}</div>
                  <div class="btn-make">免费预约</div>
                </div>
              </div>
              <div class="doctor-list-more" @click.stop="handleList(item)">查看更多></div>
           </div>
           <div style="display:inline-flex;flex:1"></div>

        </li>
        <div class="flex-row-center flex-align-center ai-content-list-loadding in" v-if="loaddingMsg">
          <img src="@/assets/ai/loading@3x.png" width="54" height="54" />
        </div>
    </ul>
    <div class="ai-content-footer">
       <div class="ai-content-footer-btn">
         <input class="input" v-auto-adjust  place v-model="inputValue" @keyup.enter="handleSend" placeholder="请输入要描述的健康问题~"></input>
        <div class="btn-send" @click="handleSend()">
         <img src="@/assets/ai/fsbutton@3x.png" width="48" height="48"/>
         </div>
       </div>
    </div>
  </div>
</template>
<script>
import {aiChat,getChatMessageList,getChatRetrieve,getAiDoctorList} from "../../api/aiApi.js";
import { Toast,InfiniteScroll  } from "mint-ui";
export default {
  components: { InfiniteScroll,Toast},
   directives: {
    // 自定义指令：自动调整输入框位置，避免被输入法遮挡
    autoAdjust: {
      inserted(el) {
        // 监听输入框获得焦点事件
        el.addEventListener('focus', () => {
          // 延迟执行，确保软键盘完全弹出
          setTimeout(() => {
            // 获取输入框的位置信息
            const rect = el.getBoundingClientRect();
            // 输入框底部到视口顶部的距离
            const bottomDistance = window.innerHeight - rect.bottom;
            
            // 如果输入框底部距离视口底部不足100px（被遮挡），则滚动页面
            if (bottomDistance < 100) {
              // 计算需要滚动的距离：当前滚动位置 + 输入框底部距离 + 额外偏移（避免贴顶）
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              // alert("????",window.pageYOffset , document.documentElement.scrollTop)
              window.scrollTo({
                // top: 20,
                top: scrollTop + (100 - bottomDistance) + 20,
                behavior: 'smooth' // 平滑滚动
              });
            }
          }, 300);
        });
        // 监听输入框失去焦点事件（软键盘收起）
        el.addEventListener('blur', () => {
              console.log("????addEventListener blur")
          // 恢复页面滚动位置
          window.scrollTo(0, 0);
        });
      }
    }
  },
  data() {
    return {
      formClient: "",
      tempDataParams: {},
      listData:[{content:`您好~</br>请简单描述您的症状，可以帮您快速找到擅长的医生~`,msgType:'in',type:'answer'}],
      doctorList:[],
      loaddingMsg:false,
      inputValue:'',
      intervalTime:'',
      displayMessage:'',
      timeoutId:'',
    };
  },
  computed:{
    ulStyle(){
      let height = window.innerHeight
      return 'max-height:'+height+'px'
    }
  },
  beforeCreate() {
    document.title = this.$route.meta.title;
  },
  mounted() {
    this.formClient = this.$route.query.formClient || "";
    console.log("....",document.body.clientHeight)
    this.$nextTick(() => {
      document.addEventListener("UniAppJSBridgeReady", function () {});
    });
    this.tempDataParams = this.$route.query;

    // 获取真实视口高度
    const viewportHeight = window.innerHeight;
    // 设置 CSS 变量（--vh 为自定义变量名）
    document.documentElement.style.setProperty('--vh', `${viewportHeight-100}px`);
    
    // 监听窗口大小变化，实时更新
    window.addEventListener('resize', () => {
      const newVh = window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${newVh-100}px`);
    });
  },
  methods: {
    loadMore(){},
     //推荐医生
    handleItem(item) {
      if (this.formClient == "bjAndroid") {
        //  window.webkit.messageHandlers.doctor.postMessage({docid: item.doc_id});
        try {
          $App.getDataFormVue(item.doc_id_dt);
        } catch (e) {
          window.webkit.messageHandlers.doctor.postMessage({
            docid: item.doc_id_dt,
          });
        }
        return;
      } else if (this.formClient == "bjIOS") {
        window.webkit.messageHandlers.doctor.postMessage({
          docid: item.doc_id_dt,
        });
        return;
      } else if (this.formClient == "h5") {
        let url = this.FEServer + "doctor/details?doc_id=" + item.doc_id + "&order_source=ai_" + this.tempDataParams.ceping_id;
        // window.location.replace(url)
        uni.navigateTo({
          url: "../doctor/details?doc_id=" + item.doc_id + "&order_source=ai_" + this.tempDataParams.ceping_id,
        });
        return;
      } else if (this.formClient == "harmony") {
        const msg = JSON.stringify({
          action: "goDetail",
          data: {
            doc_id: item.doc_id,
            order_source: "ceping_" + this.tempDataParams.ceping_id,
          },
        });
        // 方式1：使用 postMessage（推荐）
        window.jsBridge.postMessage(msg);
        return;
      }
      this.$nextTick(() => {
        console.log(">>>>>../doctor/details?doc_id=" + item.doc_id + "&order_source=ai_" + this.tempDataParams.ceping_id)
        // 向 app 发送消息
        uni.postMessage({
          data: {
            action: "doctorDetails",
            url: "../doctor/details?doc_id=" + item.doc_id + "&order_source=ai_" + this.tempDataParams.ceping_id,
          },
        });
        if (this.tempDataParams.formClient == "wechat") {
          // uni.navigateBack()
          uni.navigateTo({
            url: "../doctor/details?doc_id=" + item.doc_id + "&order_source=ai_" + this.tempDataParams.ceping_id,
          });
        }
      });
      // })
    },
    handleList(item) {
      if (this.formClient == "h5") {
        let url = this.FEServer + "search/doctor?dep_id=" + item.dep_id + "&name="+item.dep_name + "&order_source=ai_" + this.tempDataParams.ceping_id;
        // window.location.replace(url)
        uni.navigateTo({
          url: "../search/doctor?dep_id=" + item.dep_id + "&name="+item.dep_name + "&order_source=ai_" + this.tempDataParams.ceping_id,
        });
        return;
      } else if (this.formClient == "harmony") {
        const msg = JSON.stringify({
          action: "handleMore",
          data: {
            dep_id: item.dep_id,
            order_source: "ceping_" + this.tempDataParams.ceping_id,
          },
        });
        // 方式1：使用 postMessage（推荐）
        window.jsBridge.postMessage(msg);
        return;
      }
      this.$nextTick(() => {
        // document.addEventListener('UniAppJSBridgeReady', function() {
        // 向 app 发送消息
        uni.postMessage({
          data: {
            action: "doctorList",
             url: "../search/doctor?dep_id=" + item.dep_id + "&name="+item.dep_name + "&order_source=ai_" + this.tempDataParams.ceping_id,
          },
        });
        if (this.tempDataParams.formClient == "wechat") {
          // uni.navigateBack()
          uni.navigateTo({
             url: "../search/doctor?dep_id=" + item.dep_id + "&name="+item.dep_name + "&order_source=ai_" + this.tempDataParams.ceping_id,
          });
        }
      });
      // })
    },
    handleSend(){
        if(!this.inputValue){
          Toast({ message: "健康问题不能为空", duration: 1200 });
          return
        }
        this.listData.push({content:this.inputValue,msgType:'out',type:'answer'})
        this.chatMessage(this.tempDataParams["conversation_id"],this.inputValue)
        this.inputValue = ''
        this.scrollHeight()
    },
    
   scrollHeight() {
    console.log(">>>>scrollHeight")
       setTimeout(() => {
        const div = this.$refs.box;
        div.scrollTop = div.scrollHeight;
      }, 0);
    },
    //ai提问接口
    chatMessage(id,content){
        const self = this
        this.tempDataParams["conversation_id"] = id;
        this.tempDataParams["content"] = content;
        this.tempDataParams["chat_id"] = '';
        console.log("....",this.tempDataParams)
        aiChat(this.tempDataParams).then(res=>{
            console.log(">>>>res",res)
            self.getChatDataRetrieve(res.data.conversation_id,res.data.id)
            // self.getMessageList(res.data.conversation_id,res.data.id)
        })
    },
    //ai提问接口
    getChatDataRetrieve(conversation_id,id){
        const self = this
        this.tempDataParams["conversation_id"] = conversation_id;
        this.tempDataParams["content"] = '';
        this.tempDataParams["chat_id"] = id;
        console.log("....",this.tempDataParams)
        this.loaddingMsg=true
        this.scrollHeight()
        this.intervalTime = setInterval(() => {
            getChatRetrieve(this.tempDataParams).then(res=>{
                console.log(">>>>res",res)
                if(res.data.status=='completed'){
                    clearInterval(self.intervalTime)
                    self.getMessageList(res.data.conversation_id,res.data.id)
                }
            })
        },1000)
    },
    //ai提问接口
    async getMessageList(conversation_id,id){
        const self = this
        this.tempDataParams["conversation_id"] = conversation_id;
        this.tempDataParams["chat_id"] = id;
        this.tempDataParams["content"] = '';
        console.log("....",this.tempDataParams)
        getChatMessageList(this.tempDataParams).then(res=>{
            console.log(">>>>res",res)
            let result = res.data
            // 4. 调用打字函数，传入这个消息对象
            result.content = result.content
            result['msgType'] = 'in'
            result['isTyping'] = true
            self.listData.push(result)
            this.loaddingMsg=false
            this.scrollHeight()
            this.getDoctorList(this.extractDepartmentWithSplit(result.content))
            // this.typeMessage(result);
            // console.log(">>>>",result)
        })
    },
    extractDepartmentWithSplit(content) {
      const text = content;
      const prefix = "已为您推荐您所在城市的";
      const suffix = "医生";
      // 步骤一：用 "的" 分割，取后面的部分
      // ["已为您推荐您所在城市", "心脏内科医生"]
      const partAfterPrefix = text.split(prefix)[1]; 
      if (partAfterPrefix) {
        // 步骤二：用 "医生" 分割，取前面的部分
        // ["心脏内科", ""]
        const department = partAfterPrefix.split(suffix)[0];
        return department
      }
      return ''
    },
    typeMessage(message) {
        return new Promise((resolve) => {
        let index = 0;
        const timer = setInterval(() => {
            if (index < message.content.length) {
            message.displayText += message.content.charAt(index);
            index++;
            } else {
            clearInterval(timer);
            message.isTyping = false;
            resolve(); // 打字完成，resolve Promise
            }
        }, 1000);
        });
    },
    getDoctorList(department){
        const self = this
        this.tempDataParams["department"] = department;
        getAiDoctorList(this.tempDataParams).then(res=>{
            console.log(">>>>res",res)
            let result = res.data
            result.doctor_list = result.doctor_list || []
            if(result){
              if(result.doctor_list.length>0){
                let resultData = {
                  msgType:'in',
                  type:'doctorList',
                  dep_id:result.dep_id,
                  dep_name:result.name,
                  list:result.doctor_list || []
                }
                self.listData.push(resultData)
                self.scrollHeight()
              }
            }
        })
    },
  },
 
};
</script>
<style lang="scss">
.ai-content{
    background:url('~@/assets/ai/background@3x.png');
    position: fixed;
    top: 0;
    left: 0;
    /* 占满屏幕 */
    width: 100vw; /* 视口宽度 */
    max-height: 100vh; /* 视口高度 */
    height: auto;
    /* 背景图设置 */
    background-size: cover; /* 背景图自适应容器，保持比例，可能裁剪边缘 */
    background-position: center; /* 背景图居中显示 */
    background-repeat: no-repeat; /* 背景图不重复 */
    background-attachment: fixed; /* 增强兼容性，确保背景不滚动 */
    /* 层级控制：确保背景在最下层 */
    z-index: 1;
    &-list{
        list-style: none;
        margin: 0;
        padding: 0px 20px;
        display: flex;
        flex-direction: column;
        // max-height: 86vh;
        // height: 100%;
        // max-height: var(--vh)+'px';
       height: 100vh;
        position: relative;
        z-index: 2;
        /* 开启垂直滚动：内容超出高度时显示滚动条 */
        overflow-y: auto;
        &-tips{
          margin-top: 20px;
          background: linear-gradient(90deg, #CFE2FF 0%, #FFFFFF 100%);
          border-radius: 24px;
          position: relative;
          height: 210px;
          .img-right{
            right: 0;
            top: 0;
            position: absolute;
            width: 181px;
            height: 210px;
          }
          .temp-header{
              width: 180px;
              height: 40px;
              background: #5E9BFB;
              border-radius: 24px 0 24px 0;
              position: absolute;
              top:0;
              left: 0;
              img{
                width: 30px;
                height: 29px;
              }
              span{
                margin-left: 12px;
                font-weight: 500;
                font-size: 24px;
                color: #FFFFFF;
                height: 24px;
                line-height: 24px;
              }
           }
           .temp-section{
              .title{
                font-weight: bold;
                font-size: 30px;
                color: #404663;
                height: 30px;
                line-height: 30px;
              }
              .tips{
                margin-top: 30px;
                span{
                  margin-left: 8px;
                  font-weight: 500;
                  font-size: 24px;
                  color: #5E9BFB;
                  height: 24px;
                  line-height: 24px;
                }
                img{
                  width: 34px;
                  height: 36px;
                }
              }
           }
          &-temp{
            position: relative;
            z-index: 1;
            padding: 70px 34px 50px;
          }
        }
        .fengexian{
          margin-top: 46px;
          margin-bottom: 16px;
          img{
            width: 102px;
            height: 8px;
          }
        }
        &-item{
            display: flex;
            list-style: none;
            margin-top: 20px;
            // display: inline-flex;
            .item-context{
                padding: 32px 30px;
                font-weight: 500;
                font-size: 32px;
                color: #404663;
                line-height: 48px;
                word-break: break-all;
                white-space: pre-wrap;
            }
            
        }
        &-loadding{
            margin-top: 20px;
            width: 200px;
            height: 80px;
            min-height: 80px;
            img{
              height: 54px;
              width: 54px;
              animation: spin 1s linear infinite;
             }
        }
        .out-item{
            display: flex;
            justify-content: flex-end;
        }
        .in,.in-list{
            background: #FFFFFF;
            border-radius: 6px 40px 40px 40px;
        }
        .out,.out-list{
            display: inline-block;
            background: #5AAFFF;
            border-radius: 40px 40px 6px 40px;
        }
        .in-list{
          background-color: #F4FBFF;
          border-radius: 40px;

        }
        .btn-make{
          margin-top: 20px;
          width: 200px;
          height: 60px;
          background: #E4F2FF;
          border-radius: 10px;
          font-size: 28px;
          color: #5AAFFF;
          line-height: 60px;
          text-align: center;
        }
    }
    &-footer{
        position: fixed;
        bottom: 60px;
        width:100%;
        // width: 710px;
        // box-shadow: 0px 5px 29px 0px #D7ECF3;
        z-index: 2;
        // padding: 0 26px;
        &-btn{
            position: relative;
            height: 100px;
            background: #FDFDFD;
            display: flex;
            border-radius: 50px;
            margin: 0 20px;
            justify-content: center;
        }
        .input{
           width: 100%;
           height: 100%;
           border-radius: 50px;
           font-size: 32px;
           color: #1f1f1f;
           padding: 0 40px;
           border: none;
        }
        .input::placeholder{
           color: #8D97A8;
        }
       
        .btn-send{
            position: absolute;
            right: 0;
            top: 0;
            z-index: 1;
            height: 100%;
            width: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
             img{
                height: 48px;
                width: 48px;
            }
        }
    }
    /* 打字容器 */
    .typing-container {
        display: inline-block;
        overflow: hidden; /* 隐藏超出宽度的文本 */
        white-space: nowrap; /* 防止文本换行 */
        width: 0; /* 初始宽度为0 */
    }

    /* 激活打字动画 */
    .typing-active {
    /* 
        - animation-name: typing; 动画名称
        - animation-duration: 3s; 动画持续时间 (需要根据文本长度和速度调整)
        - animation-timing-function: steps(50, end); 将动画分为50步 (需要与字符数大致匹配)
        - animation-fill-mode: forwards; 动画结束后保持最后一帧的状态
    */
    animation: typing 3s steps(50, end) forwards;
    }
    /* 定义打字动画 */
    

}

@keyframes typing {
    from {
        width: 0;

    }
    to {
        width: 100%;
    }
 }

@keyframes blink {
  from, to { opacity: 1; }
  50% { opacity: 0; }
}


//**转圈圈 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


</style>
<style scoped lang="scss">
.doctor-list{
  &-item{
    margin-top: 20px;
    padding: 24px 30px;
    position: relative;
    border-bottom: 1px solid #EAEDF0;
    .doctor-avatar {
				width: 100px;
				height: 100px;
				background-color: #F7F8FA;
				border-radius: 50%;
				position: relative;
				.doctor-duodian{
					position: absolute;
					bottom: -14px;
					width: 100px;
					height: 30px;
					line-height: 30px;
					background: linear-gradient(-90deg, #D09762 0%, #D6AC84 100%);
					border-radius: 15px;
					text-align: center;
					font-size: 20px;
					color: #6D3E30;
				}
			}
      .item-temp{
        width: 528px;
        margin-left: 20px;
      }
      .doctor-details {
        .doctor-title {
          height: 32px;
          line-height: 32px;
          font-size: 32px;
          font-weight: bold;
          color: #3c3e42;
        }
        .doctor-level {
          margin-left: 18px;
          height: 26px;
          line-height: 26px;
          font-size: 28px;
          font-weight: 500;
          color: #3c3e42;
        }
      }
      .hospital-details {
        margin-top: 20px;
        padding: 0 12px;
        font-size: 24px;
        color: #FF8639;
        line-height: 40px;
        background: #FFEEE3;
        border-radius: 6px;
        display: inline-block;
      }
      .goodat{
        margin-top: 24px;
        font-size: 28px;
        color: #888888;
        line-height: 40px;
        display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
        -webkit-box-orient: vertical; // 设置或检索伸缩盒对象的子元素的排列方式
        -webkit-line-clamp: 2; // 显示两行
        overflow: hidden;
      }
  }
  &-item:last-child{
    border: none;
  }
  &-more{
    font-weight: 500;
    font-size: 28px;
    color: #5AAFFF;
    line-height: 40px;
    text-align: center;
    height: 100px;
    line-height: 100px;
  }
}
</style>